// extracted by mini-css-extract-plugin
export var rateTable = "_47-0";